// ----------------------------------------------------------------------
// <copyright file="Izenda.Tree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Tree component
 */
!(function() {


  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var TreeView = require('share/components/controls/Izenda.TreeView');
  var Input = require('share/components/controls/Izenda.Input');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var actions = require('./Izenda.TreeActions');
  const { isEmpty, invoke } = require('lodash/fp');

  var Tree = React.createClass({
    propTypes: {
      resetWorkspaceTenantsStatus: React.PropTypes.func,
      data: React.PropTypes.object.isRequired,
      dataPrev: React.PropTypes.array,
      filterText: React.PropTypes.string,
      resetPrevData: React.PropTypes.func,
      leafKey: React.PropTypes.string.isRequired
    },

    componentWillMount: function() {
      this.tree = this.props.buildTree(this.props.data, this.props.filterText);
    },

    componentWillReceiveProps: function(nextProps, nextState) {
      this.tree = this.props.buildTree(nextProps.data, nextProps.filterText);
    },

    /**
     * Render node
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderNode: function(node, toggleIcon, toggle, isCollapsed, parent) {
      var props = this.props;
      var leafKey = props.leafKey;
      var source = node.source;
      var onChangeFunc;
      var isLastItem = false;

      switch (node.nodeType) {
        case 'All':
          onChangeFunc = props.onChangeAll.bind(props, source, parent);
          break;
        case 'Category':
          onChangeFunc = props.onChangeCategory.bind(props, source, parent);
          break;
        case 'SubCategory':
          onChangeFunc = props.onChangeSubCategory.bind(props, source, parent);
          break;
        case leafKey:
          onChangeFunc = props.onChangeLeafNode.bind(props, source, parent);
          isLastItem = true;
          break;
        default:
          return null;
      }

      return this.renderData(node.source, toggleIcon, toggle, isCollapsed, parent, isLastItem, onChangeFunc);
    },

    /**
     * Render data
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderData: function(source, toggleIcon, toggle, isCollapsed, parent, isLastItem, onChangeFunc) {
      var props = this.props;
      var name = isEmpty(source.name) ? 'UNCATEGORIZED' : source.name;

      return (
        <div>
          <Input
            type="checkbox"
            indeterminate={source.indeterminate}
            checked={source.checked}
            onChange={onChangeFunc}
          />
          <TextHighLight
            highlight={props.filterText}
            onClick={toggle}
            text={name}
            className="selectable u_inline u_paddingLeft"
            tooltip={name}
          />
          {isLastItem ? null : toggleIcon}
        </div>
      );
    },

    render: function() {
      var props = this.props;
      var getChildNodes = invoke('getChildNodes');

      return (
        <TreeView
          className="u_paddingRight"
          nodes={this.tree}
          renderNode={this.renderNode}
          getKey={props.getKey}
          getChildNodes={getChildNodes}
          collapsed={false}
        />
      );
    }
  });

  module.exports = connect(actions)(Tree);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Tree/Izenda.Tree.jsx